import { Tooltip } from '../tooltip/Tooltip';
import { SelectAll } from './SelectAll';
import React from 'react';
import styled from 'styled-components';
import { Icon, mainTheme } from '@plecto/ui';
import { useTranslation } from 'react-i18next';

// Horizontal padding matches a menu row, so the placeholder lines up with the
// labels below it.
const StyledSearchBox = styled.div`
  min-height: 36px;
  padding: 0 8px;
  margin-bottom: 4px;
  display: flex;
  gap: 4px;
  align-items: center;
  border-bottom: 1px solid ${mainTheme.border.decorative};
`;

const StyledIcon = styled(Icon)`
  flex: 0;
`;

const StyledSearchIcon = styled(StyledIcon)`
  color: ${mainTheme.text.tertiary};
`;

const StyledSearchClearIcon = styled(StyledIcon)`
  cursor: pointer;
  color: ${mainTheme.text.secondary};
`;

const StyledSearchInput = styled.input`
  border: none;
  background: transparent;
  flex: 1;
  outline: none;
  font-weight: 400;

  &::placeholder {
    color: ${mainTheme.form.input.placeholderColor};
  }

  &:hover, &:focus, &L:active {
    border: none;
    outline: none;
  }
`;

type FilterDropdownMenuHeaderProps = {
    searchInputValue: string;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSearchForceChange: (value: string) => void;
    selectableCount: number;
    onToggle: () => void;
    allSelected: boolean;
    canSelectAll: boolean;
}

export function FilterDropdownMenuHeader({
	searchInputValue,
	onSearchChange,
	onSearchForceChange,
	selectableCount,
	onToggle,
	canSelectAll,
	allSelected,
}: FilterDropdownMenuHeaderProps) {
	const { t } = useTranslation();
	const onClearSearch = () => onSearchForceChange('');

	const showSelectAll = canSelectAll && selectableCount !== 0;

	return <>
		<StyledSearchBox>
			<StyledSearchInput
				value={searchInputValue}
				onChange={onSearchChange}
				placeholder={t('Search')}
				autoFocus />
			{searchInputValue ? <Tooltip message={'Clear search'} placement={'top'}>
				<StyledSearchClearIcon icon={'x'} onClick={onClearSearch} />
			</Tooltip> : <StyledSearchIcon icon={'magnifying-glass'} />}
		</StyledSearchBox>
		{ showSelectAll ? <SelectAll
			onToggle={onToggle}
			count={selectableCount}
			allSelected={allSelected}
		/> : null}
	</>;

}
